(function () {
    'use strict';
    angular.module('nasracApp').factory('ChangeManagementHoursReport', ChangeManagementHoursReport);

    ChangeManagementHoursReport.$inject = ['$resource'];

    function ChangeManagementHoursReport($resource) {
        var resourceUrl = 'api/changemanagementhoursreport';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCurrentUser': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/currentUser',
                isArray: false
            },

            'getReportYears': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/reportYear',
                isArray: true
            },
            'getCustomerList': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/allcllicodeCustomer',
                isArray: true
            },
            'getClliCodeList': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/allcllicode',
                isArray: true
            },
            'loadDataHoursReport': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/changeManagementHoursReport',
                isArray: true
            },
            'download': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {
                            type: xlsxContentType
                        })
                    };
                }
            },

        });
    }
})();
